import tmhRequest from '@/config/tmhRequest'


export default {
    searchCrossStoreOrderCount: function (data) {
        return tmhRequest({
            url: '/order/ispa/crossstoreorder/searchcrossstoreordercount',
            method: 'post',
            data: data,
        })
    },
    searchCrossStoreOrderByPage: function (data) {
        return tmhRequest({
            url: '/order/ispa/crossstoreorder/searchcrossstoreorderbypage',
            method: 'post',
            data: data,
        })
    },

    exportCrossStoreOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/crossstoreorder/exportcrossstoreorder',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/order/crossstoreorder.js